import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Form } from 'semantic-ui-react';
import { setSearch } from '../../data/searchField/actions';
import SearchField from './SearchField';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupName: (props.searchFields && props.searchFields.groupName) || '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const { setSearchFields } = this.props;
    const variableArguments = {
      groupName: value,
    };
    this.setState({ [name]: value });
    setSearchFields(variableArguments);
  }

  render() {
    const { onSubmit, searchOptions } = this.props;
    const { groupName } = this.state;
    const values = { groupName };

    return (
      <div>
        <Form onSubmit={onSubmit}>
          <Form.Group widths='two'>
            {map(searchOptions, searchOption => (
              <SearchField
                handleInputChange={this.handleInputChange}
                searchOption={searchOption}
                value={values[searchOption]}
                key={searchOption}
              />
            ))}
            <Form.Field>
              <Form.Button color='green' inverted>
                Search
              </Form.Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

Search.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  searchFields: PropTypes.object,
  searchOptions: PropTypes.array,
  setSearchFields: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
});

export default compose(connect(null, mapDispatchToProps))(Search);
